export enum types {
  SEARCH_SET = 'search/set',
}
